export default __webpack_public_path__ + "static/media/img3.6877bb2e.svg";